// ** Redux
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ############################################################

// Async thunks
export const getNewsJson = createAsyncThunk(
	"pages/news/getNewsJson",
	createApiCall(async ({ page = 1, language, hash }, client) => {
		client.modifyLanguageHeader(language);
		const response = await client.get(`/datezone/news`, {
			params: {
				page,
			},
			headers: {
				Accept: "application/api.1.1+json",
			},
		});
		return { data: response.data, counters: response.counters, hash };
	})
);

export const getSingleNewsJson = createAsyncThunk(
	"pages/news/getSingleNewsJson",
	createApiCall(async ({ newsId, language, hash }, client) => {
		client.modifyLanguageHeader(language);
		const response = await client.get(`/datezone/news/single`, {
			params: {
				id: newsId,
			},
		});
		return {
			data: response.data,
			counters: response.counters,
			language,
			hash,
		};
	})
);

// ############################################################

// Initial state
const initialState = {
	news: {
		loading: false,
		hash: "",
		data: [],
		pagination: {
			currentpage: 1,
			totalpages: 1,
		},
	},
	singleNews: {
		loading: false,
		hash: "",
		error: false,
		lang: "",
		data: {},
	},
};

// ############################################################

// Slice
const servicePageNewsSlice = createSlice({
	name: "service-pages/news",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			// getNewsJson
			.addCase(getNewsJson.pending, (state) => {
				state.news.loading = true;
			})
			.addCase(getNewsJson.fulfilled, (state, action) => {
				state.news.loading = false;
				state.news.hash = action.payload.hash;
				state.news.data = action.payload.data?.news ?? [];
				state.news.pagination.currentpage =
					action.payload.data?.pagination.currentpage ?? 1;
				state.news.pagination.totalpages =
					action.payload.data?.pagination.totalpages ?? 1;
			})
			.addCase(getNewsJson.rejected, (state) => {
				state.news.loading = false;
			})

			// getSingleNewsJson
			.addCase(getSingleNewsJson.pending, (state) => {
				state.singleNews.loading = true;
				state.singleNews.data = {};
			})
			.addCase(getSingleNewsJson.fulfilled, (state, action) => {
				state.singleNews.loading = false;
				state.singleNews.hash = action.payload.hash;
				state.singleNews.error = false;
				state.singleNews.lang = action.payload.language;
				state.singleNews.data = action.payload.data ?? {};
			})
			.addCase(getSingleNewsJson.rejected, (state) => {
				state.singleNews.loading = false;
				state.singleNews.error = true;
			});
	},
});

// ############################################################

export default servicePageNewsSlice.reducer;

// ############################################################
